import { useEffect } from 'react';
import { getElementById, isAdaptiveActive } from '../helpers/ElementHelpers';
import { isMobile } from '../helpers/DeviceHelpers';

export const useAdaptiveVisibility = (
    show: boolean,
    adaptive: boolean,
    disabled: boolean,
    setLocalDisabled: (disabled: boolean) => void) => {
    useEffect(() => {

        if (!isMobile()) return;

        const appBarElem: HTMLElement | null = getElementById("AppBar");
        const bottomMenuElem: HTMLElement | null = getElementById("bottom-menu");

        if (!appBarElem || !bottomMenuElem) return;

        if (show && adaptive && isAdaptiveActive()) {
            appBarElem.classList.add("app-bar-hidden");
            bottomMenuElem.classList.add("bottom-menu-hidden");
        }
        if (!show) {
            appBarElem.classList.remove("app-bar-hidden");
            bottomMenuElem.classList.remove("bottom-menu-hidden");

            if (!disabled) {
                setLocalDisabled(true);
                setTimeout(() => setLocalDisabled(false), 100);
            }
        }
    }, [show, adaptive]);
};
